
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import NavigationSidebar from "@components/new-styleguide/NavigationSidebar.vue";

@Component({
  name: 'AppPage',
  components: {
    NavigationSidebar
  },
})
export default class AppPage extends Vue {
  @Prop({ default: true })
  private showSidebar: boolean;

  created () {
    // body is hidden in index.html until this component gets created, then "show-oeamtc-page" is added so the page is visible now
    document.getElementById('oeamtc-page').classList.add("show-oeamtc-page");
  }

  get headerFooterHidden() {
    return navigator.userAgent.includes('oeamtc_hybrid/oeamtc_app');
  }

  get showNavSidebar() {
    return this.showSidebar && !this.headerFooterHidden;
  }
}
